import { cn } from '@eliadmin/core/src/utils/style-utils';

export function Heading({ title, className, as: Tag = 'h3' }: { title: string; className?: string; as?: 'h2' | 'h3' }) {
  return (
    <Tag data-ea-visual-tag="h3" className={cn('text-3xl text-foreground sm:text-4xl lg:text-5xl', className)}>{title}</Tag>
  );
}
